<script>
  let { path = [], highlightLast = true, lightText = false } = $props();
  
  // Get icon for different types
  function getIcon(type) {
    switch(type) {
      case 'space':
        return `<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>`;
      case 'container':
        return `<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>`;
      case 'item':
        return `<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>`;
      default:
        return `<svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>`;
    }
  }
  
  // Get color classes for different types
  function getColorClasses(type, isLast = false) {
    const baseClasses = isLast && highlightLast ? 'font-medium' : 'font-normal';
    
    if (lightText) {
      return `${baseClasses} text-white ${isLast && highlightLast ? 'text-white font-semibold' : 'text-white/90'}`;
    }
    
    switch(type) {
      case 'space':
        return `${baseClasses} text-brand-700 ${isLast && highlightLast ? 'text-brand-900' : ''}`;
      case 'container':
        return `${baseClasses} text-amber-700 ${isLast && highlightLast ? 'text-amber-900' : ''}`;
      case 'item':
        return `${baseClasses} text-brand-800 ${isLast && highlightLast ? 'text-brand-900' : ''}`;
      default:
        return `${baseClasses} text-gray-700 ${isLast && highlightLast ? 'text-gray-900' : ''}`;
    }
  }
  
  // Format container type for display
  function formatContainerType(type) {
    if (!type) return '';
    return type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  
  // Format category for display
  function formatCategory(category) {
    if (!category) return '';
    return category.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
</script>

<div class="hierarchy-path">
    {#if path && path.length > 0}
    <div class="flex flex-wrap items-center gap-2 text-sm">
      {#each path as item, index}
        {#if item && item.name}
          {@const isLast = index === path.length - 1}
          
          <!-- Item content -->
          <div class="flex items-center gap-1 {getColorClasses(item.type, isLast)}">
            <!-- Icon -->
            <span class="flex-shrink-0">
              {@html getIcon(item.type)}
            </span>
            
            <!-- Name and details -->
            <span class="truncate">
              {item.name}
              {#if item.type === 'container' && item.container_type}
                <span class="text-xs ml-1 {lightText ? 'text-white/60' : 'text-gray-500'}">({formatContainerType(item.container_type)})</span>
              {/if}
              {#if item.type === 'item' && item.category}
                <span class="text-xs ml-1 {lightText ? 'text-white/60' : 'text-gray-500'}">({formatCategory(item.category)})</span>
              {/if}
            </span>
          </div>
          
          <!-- Arrow between items (except for last item) -->
          {#if !isLast}
            <svg class="h-3 w-3 flex-shrink-0 mx-1 {lightText ? 'text-white/50' : 'text-gray-400'}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          {/if}
        {/if}
       {/each}
    </div>
  {:else}
    <div class="text-sm italic {lightText ? 'text-white/70' : 'text-gray-500'}">
      No location specified
    </div>
  {/if}
</div>

<style>
  .hierarchy-path {
    min-height: 1.5rem;
  }
  
  /* Truncate long names but keep structure visible */
  .hierarchy-path span {
    max-width: 150px;
  }
  
  /* Responsive adjustments */
  @media (max-width: 640px) {
    .hierarchy-path span {
      max-width: 100px;
    }
  }
</style> 